import React from 'react';

const HGFooter = () => {
    return (
        <div className="relative w-full p-3">
            <div className="ml-auto text-sm w-fit">
                <a
                    href="https://www.homegridenergy.com/privacy-policy/general"
                    rel="noreferrer"
                    className="text-muted-foreground hover:underline"
                >
                    privacy policy
                </a>
            </div>
        </div>
    );
};

export default HGFooter;
